import * as React from 'react';
import { withRouteData, Head as HeadHelmet } from 'react-static';
import { connect } from 'react-redux';
import { RootState } from '../../RootState';

interface HeadProps {
  title: string;
  description: string;
}

const Head: React.SFC<HeadProps> = ({ title, description }) => (
  <HeadHelmet>
    <title>{title}</title>
    <meta name="description" content={description} />
  </HeadHelmet>
);

const mapStateToProps = (state: RootState) => ({
  description:
    state.localization.language === 'cz'
      ? 'Peering.cz - Internet exchange point v České republice, Rakousku, Německu a na Slovensku'
      : 'Peering.cz - Internet exchange point in Czech Republic, Slovakia, Austria and Germany',
});

export default withRouteData(connect(mapStateToProps)(Head));



// WEBPACK FOOTER //
// /www/client/src/components/Layout/Head.tsx